/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  ITicketPortalInputReplyFromCustomer,
  ITicketPortalInputFilesUpload,
  ITicketPortalInputUpdateProfile,
} from '../types/request.types'
import {
  ITicketPortalOutputListing,
  ITicketPortalOutputDetail,
  ITicketPortalOutputLogoutWithRedirectLink,
  ITicketPortalOutputProfile,
  IGenericJSONMessage,
  IPostSuccess,
} from '../types/response.types'

export default new class TicketPortalAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Listing(
    mailbox_id: any,
  ): Promise<ITicketPortalOutputListing> {
    return await this.get({
      url: `/ticket-portal/mailbox/${mailbox_id}`,
    })
  }
  public async get_Detail(
    convo_id: any,
  ): Promise<ITicketPortalOutputDetail> {
    return await this.get({
      url: `/ticket-portal/detail/${convo_id}`,
    })
  }
  public async get_LogoutWithRedirectLink(
    mailbox_id: any,
  ): Promise<ITicketPortalOutputLogoutWithRedirectLink> {
    return await this.get({
      url: `/ticket-portal/logout/${mailbox_id}`,
    })
  }
  public async get_Profile(
    mailbox_id: any,
  ): Promise<ITicketPortalOutputProfile> {
    return await this.get({
      url: `/ticket-portal/mailbox/${mailbox_id}/profile`,
    })
  }
  /****** POST methods *****/
  public async post_ReplyFromCustomer(
    convo_id: any,
    data: ITicketPortalInputReplyFromCustomer,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/ticket-portal/detail/${convo_id}/reply-from-customer`,
      data,
    })
  }
  public async post_FilesUpload(
    convo_id: any,
    data: ITicketPortalInputFilesUpload,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/ticket-portal/detail/${convo_id}/files/upload`,
      data,
    })
  }
  /****** PUT methods *****/
  public async put_Profile(
    mailbox_id: any,
    data: ITicketPortalInputUpdateProfile,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/ticket-portal/mailbox/${mailbox_id}/profile`,
      data,
    })
  }
  /****** DELETE methods *****/
  public async delete_FileUploadDelete(
    convo_id: any,
    file_upload_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/ticket-portal/detail/${convo_id}/files/${file_upload_id}`,
    })
  }
}()
